<section *ngFor="let item of items"
         class="unordered-list-one">
       <rappider-unordered-list-one [titleIcon]="item.titleIcon"
                                    [title]="item.title"
                                    [list]="item.list"></rappider-unordered-list-one>
</section>
